import { Arrayable } from "../types/common";

/*
 * Inserts double underline between values
 */
export const insertUnderlineBetween = (values: any[]): string =>
  values.map((val, idx, arr) => (idx < arr.length - 1 ? `${val}__` : `${val}`)).join("");

export interface IDropdownValue<T> {
  value: T;
  label: string;
}

export const makeKey = (prefix: Arrayable<string | number>, index: string | number) => {
  if (Array.isArray(prefix)) {
    prefix = prefix.reduce((acc: string, cur) => `${acc}-${cur}`, "");
  }

  return `${prefix}-${index}`;
};

export const objectToQueryString = (object: any) => {
  return Object.keys(object)
    .map((key) => key + "=" + object[key as keyof typeof object])
    .join("&");
};

export const arrayDiff = (list1: any[], list2: any[], compare: (item: any) => string | number) => {
  return list1.filter(
    ((set) => (a: any) => !set.has(compare(a)))(new Set(list2.map((b: any) => compare(b))))
  );
};
